import React, { useContext } from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  Flex,
  Image,
  VStack,
  StackDivider,
  HStack,
  useToast,
} from "@chakra-ui/react";
import { HomeContext } from "../../context/HomeContext";
import { useNavigate } from "react-router-dom";
import IconCardXXL from "../../components/layouts/IconCardXXL";
import Picto1 from "../picto/Picto1.png";
import Picto2 from "../picto/Picto2.png";
import Picto3 from "../picto/Picto3.png";
import logo from "../../assets/logo.png";
import BrochureITE from "../../assets/Brochure ISO-HSE-06-2025-web.pdf";

const ITE = () => {
  const [formData, setFormData, defaultFormData] = useContext(HomeContext);
  const navigate = useNavigate();
  const toast = useToast();

  const handleStartITE = () => {
    navigate("/client-info-ite");
  };

  const handleManuals = () => {
    navigate("manuals-ite");
  };

  const handleBack = () => {
    navigate("/");
  };

  const handleReset = () => {
    localStorage.removeItem("formDataITE");
    toast({
      title: "Formulaire ITE réinitialisé",
      description: "Le formulaire ITE a été réinitialisé avec succès.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    window.location.reload();
  };

  const handleDownloadBrochure = () => {
    const link = document.createElement("a");
    link.href = BrochureITE;
    link.setAttribute("download", "Brochure_ITE.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box width="full" px={20}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mb="30px"
        mt="20px"
      >
        <Image src={logo} w="150px" alt="Home Solution Logo" />
        <Button
          w="120px"
          bgColor={"white"}
          color={"#30C9FF"}
          fontWeight={"600"}
          borderRadius={"8px"}
          border="1px solid"
          borderColor="#30C9FF"
          _hover={{
            bgColor: "#30C9FF",
            color: "white",
            transform: "translateY(-2px)",
            transition: "all 0.2s",
          }}
          onClick={handleBack}
        >
          Retour
        </Button>
      </Flex>
      <Box display={"flex"} flexDirection={"row"}>
        <Box display={"flex"} flexDirection={"column"}>
          <Heading fontSize={"28px"} mb={1} fontWeight={"510"}>
            Sélectionner votre objectif
          </Heading>
          <Text mb={8} color="#8C8C8C" fontWeight={"400"} fontSize="20px">
            Sélectionner une option pour continuer
          </Text>
        </Box>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        borderColor={"#F4F4F4"}
        p={{ base: "30px", md: "30px 86px" }}
        gap="71px"
        borderRadius="8px"
        bg="#FCFDFF"
        align="center"
        justifyContent={"center"}
        bgColor={"white"}
      >
        <Box display={"flex"} flexDirection={"row"}>
          {/* Section Commencer l'étude ITE */}
          <Box mr={"20px"} flex="1">
            <Box
              display={"flex"}
              w={"289px"}
              mb={"20px"}
              h={"418px"}
              flexDirection={"column"}
              alignItems={"center"}
              borderRadius={"20px"}
              padding={"10px, 10px, 20px, 10px"}
              borderWidth={"1px"}
            >
              <IconCardXXL icon={Picto1}></IconCardXXL>
              <Text
                mt={"20px"}
                fontSize={"25px"}
                fontWeight="510"
                textTransform="uppercase"
              >
                COMMENCER
              </Text>
              <Text
                fontWeight="510"
                mt={"10px"}
                fontSize={"20px"}
                mb={"35px"}
                color={"#8C8C8C"}
                textAlign="left"
              >
                Commencer votre étude ITE
              </Text>
              <Button
                w="238px"
                bgColor="#30C9FF"
                color="#FCFDFF"
                borderRadius="8px"
                padding="8px 16px"
                onClick={handleStartITE}
              >
                COMMENCER
              </Button>
            </Box>
          </Box>

          {/* Section Télécharger */}
          <Box mr={"20px"} flex="1">
            <Box
              display={"flex"}
              w={"289px"}
              mb={"20px"}
              h={"418px"}
              flexDirection={"column"}
              alignItems={"center"}
              borderRadius={"20px"}
              padding={"10px, 10px, 20px, 10px"}
              borderWidth={"1px"}
            >
              <IconCardXXL icon={Picto2}></IconCardXXL>
              <Text
                mt={"20px"}
                fontSize={"25px"}
                fontWeight="510"
                textTransform="uppercase"
              >
                TELECHARGER
              </Text>
              <Text
                fontWeight="510"
                mt={"10px"}
                fontSize={"20px"}
                mb={"35px"}
                color={"#8C8C8C"}
                textAlign="left"
              >
                Déscriptifs produits ITE
              </Text>
              <Button
                w="238px"
                bgColor="#30C9FF"
                color="#FCFDFF"
                borderRadius="8px"
                padding="8px 16px"
                onClick={handleDownloadBrochure}
              >
                DOWNLOAD
              </Button>
            </Box>
          </Box>

          {/* Section Réinitialiser */}
          <Box flex="1">
            <Box
              display={"flex"}
              w={"289px"}
              mb={"20px"}
              h={"418px"}
              flexDirection={"column"}
              alignItems={"center"}
              borderRadius={"20px"}
              padding={"10px, 10px, 20px, 10px"}
              borderWidth={"1px"}
            >
              <IconCardXXL icon={Picto3}></IconCardXXL>
              <Text
                mt={"20px"}
                fontSize={"25px"}
                fontWeight="510"
                textTransform="uppercase"
              >
                REINITALISER
              </Text>
              <Text
                fontWeight="510"
                mt={"10px"}
                fontSize={"20px"}
                mb={"35px"}
                color={"#8C8C8C"}
                textAlign="left"
              >
                Reinitialiser votre étude
              </Text>
              <Button
                w="238px"
                bgColor="#30C9FF"
                color="#FCFDFF"
                borderRadius="8px"
                padding="8px 16px"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default ITE; 